// @ts-nocheck
import React from "react";
import axios from 'axios';
import Modal from '@mui/material/Modal';
import { ContenedorConfirmacion} from "../../Componentes/ModalConfirmacion";
import {setupInterceptorsTo} from "../../Componentes/API/AxiosBuilder";
import {RUTA_API_USUARIOS} from "../../Contantes/Constantes";
import {useBody} from "../../Body/state/BodyContext";
import {useUsuarios} from "../State/UsuarioContext";


export const ModalBorrarUsuario = ({open, onClose,uid}) => {
    const {getAltasPendientes} = useUsuarios();
    const {setMessage,setSuccess} = useBody();
    const axiosInstance = setupInterceptorsTo(axios.create());
    const peticionDelete = async () => {
        await axiosInstance({
            method: 'DELETE',
            url: `${RUTA_API_USUARIOS}/users/${uid} `,
        })
            .then(response=>{
                onClose();
                setSuccess("Usuario borrado con exito");
                getAltasPendientes()
            }).catch(error=>{
                setMessage("Hubo un error al intentar borrar usuario (Codigo de error: 00040)");
        })
    }

    const mensajePrimario = <b>¿Estas seguro de querer eliminar el usuario?</b>;
    const mensajeSecundario = <p>Al presionar <i>Si , eliminar</i>,<b> el usuario será eliminado y esta acción no puede revertirse.</b></p>;
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <ContenedorConfirmacion
            mensajePrimario={mensajePrimario}
            mensajeSecundario={mensajeSecundario}
            accion={() => peticionDelete()}
            mensajeAceptar={"Si , eliminar"}
            handleClose={onClose}
            colorAceptar="red"
            />
        </Modal>
    );
};